import * as shimmer from 'shimmer';
var MonkeyPatched = /** @class */ (function () {
    function MonkeyPatched() {
        this.enabled = false;
    }
    MonkeyPatched.prototype.enable = function () {
        if (!this.enabled) {
            this.enabled = true;
            for (var _i = 0, _a = this.patches(); _i < _a.length; _i++) {
                var patch = _a[_i];
                shimmer.wrap(patch.nodule, patch.name, patch.wrapper());
            }
        }
    };
    MonkeyPatched.prototype.disable = function () {
        if (this.enabled) {
            this.enabled = false;
            for (var _i = 0, _a = this.patches(); _i < _a.length; _i++) {
                var patch = _a[_i];
                shimmer.unwrap(patch.nodule, patch.name);
            }
        }
    };
    return MonkeyPatched;
}());
export { MonkeyPatched };
